var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_4091",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 4091",
    transform: "translate(532.722 16335) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_18098",
    "data-name": "\\u9577\\u65B9\\u5F62 18098",
    transform: "translate(16305 -532.722)",
    fill: "#fff",
    stroke: "#bebebe",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_389",
    "data-name": "\\u30D1\\u30B9 389",
    d: "M89.26,153.149l-7.191-7.191,1.048-1.048,6.143,6.143,6.137-6.137,1.048,1.048Z",
    transform: "translate(16230.89 -666.836)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerArrow);
export default __webpack_public_path__ + "static/media/banner-arrow.ea5cda637d9e3facfadc7b5312fb66cb.svg";
export { ForwardRef as ReactComponent };